(function () {
  var DALLAS_PRODUCT =
    "https://eclectic-coins.com/products/dallas-tx-1-goldback?variant=53898200613236";
  var DASH_STATES = {
    "Dallas, TX": true,
    "Washington DC": true,
  };

  function parseMintage(value) {
    if (!value || value === "?" || value === "-") return null;
    var cleaned = value.replace(/,/g, "").trim();
    if (!/\d/.test(cleaned)) return null;
    var num = Number(cleaned);
    return Number.isFinite(num) ? num : null;
  }

  function formatMintage(num) {
    return num > 0 ? num.toLocaleString("en-US") : "-";
  }

  document.querySelectorAll('[class*="ai-goldback-table"], [class*="gg-mintage-table"]').forEach(function (table) {
    var totals = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    var activeState = "";

    table.querySelectorAll("tbody tr").forEach(function (row) {
      var header = row.querySelector('[class*="state-header"]');
      if (header) {
        activeState = header.textContent.trim();
        return;
      }

      if (row.querySelector('[class*="totals"]') || row.querySelector("[data-mintage-total]")) {
        return;
      }

      var cells = Array.prototype.slice.call(row.querySelectorAll("td")).slice(1);
      cells.forEach(function (cell, index) {
        var link = cell.querySelector("a");
        var value = link ? link.textContent.trim() : cell.textContent.trim();

        if (DASH_STATES[activeState] && link) {
          if (!value || value === "?") {
            value = "-";
            link.textContent = "-";
          }
          if (activeState === "Dallas, TX") {
            var href = link.getAttribute("href") || "";
            if (href.indexOf("/collections/goldbacks") !== -1) {
              link.setAttribute("href", DALLAS_PRODUCT);
            }
          }
        }

        var amount = parseMintage(value);
        if (amount !== null && index < totals.length) {
          totals[index] += amount;
        }
      });
    });

    var totalsRow = table.querySelector('[class*="totals"]');
    if (!totalsRow) return;

    var totalCells = Array.prototype.slice.call(totalsRow.querySelectorAll("td")).slice(1);
    totalCells.forEach(function (cell, index) {
      if (index >= totals.length) return;
      cell.setAttribute("data-mintage-total", String(totals[index]));
      cell.textContent = formatMintage(totals[index]);
    });
  });
})();